<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cx5QiM/tc-custom/9781631958823.jpg?1736221840637" alt="This image is the cover for the book Beyond the Rainbow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beyond the Rainbow
      </h1>
      <p class="bookDescription body article font2">
        <p>In June of 2012, vibrant 16-year-old Leanna Mae Knopik was hospitalized with a rare and sudden cardiac infection. In this unflinching account of her final month of life and the searing sorrow that followed, a grieving mother deepens her relationship with her deceased daughter and‚Äîthrough the grace of God‚Äîfinds a path to true joy.</p><p>Beyond the Rainbow describes in candid detail the arduous task of piecing a family back together in the wake of tragedy, and the transformative spiritual awakening that emerges. Not just for the bereaved, all readers will benefit from the author‚Äôs journey through searing pain and her ultimate discovery of God‚Äôs grace. This memoir offers a model for how family members can move through grief. It presents an honest and complete examination of the coping skills that worked for the author and her family‚Äîand the ones that did not. </p><p>The goal of Beyond the Rainbow is twofold: 1) to shorten the path to healing by offering a roadmap through the early stages of grief, and 2) to broaden the reader‚Äôs perspective on loss; with God‚Äôs grace, they can and will live a joyful life.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth  Knopik
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?80a36e08